<div *ngIf="items" class="node-helipad full-grow-no-shrink-no-basis">
    <div *ngFor="let item of items" class="node-helipad full-grow-no-shrink-no-basis">
        <app-platform-tool-dialog-definition-container
                [platformDialog]="item"></app-platform-tool-dialog-definition-container>
    </div>
</div>
